import React from "react";
import { Grid } from "react-window";
import type { Range } from "../../../utils";
import AttributeValue from "../AttributeValue/AttributeValue";
import Dialog from "../../common/Dialog/Dialog";
import { formatDate } from "./utils";

export type TemporalModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  ranges: Range[];
  node?: any;
};

interface CellProps {
  ranges: Range[];
}

const headers = ["From", "To", "Value"];

const Cell = ({
  columnIndex,
  rowIndex,
  style,
  ranges,
}: {
  columnIndex: number;
  rowIndex: number;
  style: React.CSSProperties;
  ariaAttributes: { "aria-colindex": number; role: "gridcell" };
} & CellProps) => {
  if (rowIndex === 0) {
    return (
      <div
        style={{
          ...style,
          display: "flex",
          alignItems: "center",
          boxSizing: "border-box",
        }}
        data-temporal-value-part="table-header-cell"
      >
        {headers[columnIndex]}
      </div>
    );
  }

  const item = ranges[rowIndex - 1];
  let content: React.ReactNode;

  switch (columnIndex) {
    case 0:
      content = formatDate(item.r.start);
      break;
    case 1:
      content = formatDate(item.r.end);
      break;
    case 2:
      content = <AttributeValue node={{ input: item.v }} showType={false} />;
      break;
    default:
      content = "";
  }

  return (
    <div
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        boxSizing: "border-box",
      }}
      data-temporal-value-part="table-cell"
    >
      {content}
    </div>
  );
};

const TemporalModal = (props: TemporalModalProps) => {
  const { open, onOpenChange, ranges, node } = props;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>
            Timeline
          </Dialog.Title>
          <Dialog.Controls />
        </Dialog.Header>

        <Dialog.Body>
          {node?.description || node?.id ? (
            <div data-temporal-value-part="modal-attribute-info">
              <strong>Attribute</strong>
              <div>{node.description || node.id}</div>
            </div>
          ) : null}

          <div data-temporal-value-part="table-container">
            <Grid<CellProps>
              columnCount={3}
              columnWidth="33.333%"
              rowCount={ranges.length + 1}
              rowHeight={53}
              style={{ height: Math.min(400, (ranges.length + 1) * 53), width: "100%" }}
              cellComponent={Cell}
              cellProps={{ ranges }}
            />
          </div>
        </Dialog.Body>
        <Dialog.Actions />
      </Dialog.Content>
    </Dialog>
  );
};

export default TemporalModal;
